<template>
  <div :style="combineStyles()" :class="className ? className : 'Title'">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['className', 'color', 'vStyle', 'size'],

  methods: {
    combineStyles() {
      return { ...this.fontSize(), ...this.fontColor(), ...this.vStyle };
    },
    fontSize() {
      if (this.size) return { '--title-f-size': this.size };
      return {};
    },
    fontColor() {
      if (this.color) return { '--title-f-color': this.color };
      return {};
    },
  },
};
</script>
<style scoped>
.Title {
  --title-f-size: 20px;
  color: var(--title-f-color, #2b4047);
  font-size: var(--title-f-size);
  font-weight: bold;
  font-family: Foco;
}

@media (min-width: 1024px) {
  .Title {
    --title-f-size: 40px;
  }
}

@media (min-width: 1280px) {
  .Title {
    --title-f-size: 50px;
  }
}

@media (min-width: 1400px) {
  .Title {
    --title-f-size: 60px;
  }
}
@media (min-width: 1800px) {
  .Title {
    --title-f-size: 70px;
  }
}
</style>
